export const imagesTranslations = {
  en: {
    images: {
      captions: {
        aiFinance: "Artificial Intelligence is transforming personal finance management",
        aiInvestment: "AI revolution: opportunities for investors in artificial intelligence",
        automateFinances: "Automate your finances: set it and forget it for financial success",
        beforeQuittingJob: "Before you quit: financial considerations for career transitions",
        couplesFinance: "Managing finances as a couple: communication is key",
        cryptoTaxGuide: "Cryptocurrency taxes: understanding your obligations",
        digitalNomadTax: "Working remotely from anywhere: navigating taxes as a digital nomad",
        digitalScams: "Protect yourself: learn to identify and avoid digital scams",
        esgGreenwashing: "ESG investing: learn to identify genuine sustainable investments",
        fearOfInvesting: "Overcoming the fear of investing: knowledge is power",
        financialPlanningChildren: "Planning for parenthood: financial preparation makes all the difference",
        howMuchToRetire: "How much do you need to retire comfortably?",
        inflationSavings: "Protect your savings from inflation with smart strategies",
        investingMistakes: "Learning from common investment mistakes can save you thousands",
        investingWith100: "Starting small: $100 can be the beginning of your investment journey",
        irpfGuide: "Understanding income tax: a comprehensive guide",
        lowSalarySaving: "Every dollar counts: smart strategies for saving on a low salary",
        onePercentRule: "The 1% rule: small consistent improvements lead to big results",
        preparingParenthood: "Financial preparation is key before welcoming a new family member",
        rentingVsBuying: "Renting vs buying: one of the biggest financial decisions you'll make",
        salaryNegotiation: "Master the art of salary negotiation to maximize your earning potential",
        selfEmployedFinances: "Self-employment: freedom requires financial discipline",
        utilityBills: "Reduce your utility bills with smart strategies",
        whyTradersLose: "Why do most traders lose money? Understanding the psychology and statistics",
      },
    },
  },
  es: {
    images: {
      captions: {
        aiFinance: "La Inteligencia Artificial está transformando la gestión de las finanzas personales",
        aiInvestment: "Revolución de la IA: oportunidades para inversores en inteligencia artificial",
        automateFinances: "Automatiza tus finanzas: configúralo y olvídate para el éxito financiero",
        beforeQuittingJob: "Antes de renunciar: consideraciones financieras para cambios de carrera",
        couplesFinance: "Gestionar las finanzas en pareja: la comunicación es clave",
        cryptoTaxGuide: "Impuestos de criptomonedas: entiende tus obligaciones",
        digitalNomadTax: "Trabajar remotamente desde cualquier lugar: navegando impuestos como nómada digital",
        digitalScams: "Protégete: aprende a identificar y evitar estafas digitales",
        esgGreenwashing: "Inversión ESG: aprende a identificar inversiones sostenibles genuinas",
        fearOfInvesting: "Superar el miedo a invertir: el conocimiento es poder",
        financialPlanningChildren: "Planificar la paternidad: la preparación financiera marca la diferencia",
        howMuchToRetire: "¿Cuánto necesitas para jubilarte cómodamente?",
        inflationSavings: "Protege tus ahorros de la inflación con estrategias inteligentes",
        investingMistakes: "Aprender de los errores comunes de inversión puede ahorrarte miles",
        investingWith100: "Empezar pequeño: 100€ pueden ser el comienzo de tu viaje inversor",
        irpfGuide: "Entendiendo el impuesto sobre la renta: una guía completa",
        lowSalarySaving: "Cada euro cuenta: estrategias inteligentes para ahorrar con un salario bajo",
        onePercentRule: "La regla del 1%: pequeñas mejoras consistentes llevan a grandes resultados",
        preparingParenthood: "La preparación financiera es clave antes de dar la bienvenida a un nuevo miembro de la familia",
        rentingVsBuying: "Alquilar vs comprar: una de las decisiones financieras más importantes que tomarás",
        salaryNegotiation: "Domina el arte de la negociación salarial para maximizar tu potencial de ingresos",
        selfEmployedFinances: "Autónomo: la libertad requiere disciplina financiera",
        utilityBills: "Reduce tus facturas de servicios con estrategias inteligentes",
        whyTradersLose: "¿Por qué la mayoría de traders pierden dinero? Entendiendo la psicología y estadísticas",
      },
    },
  },
  de: {
    images: {
      captions: {
        aiFinance: "Künstliche Intelligenz transformiert das persönliche Finanzmanagement",
        aiInvestment: "KI-Revolution: Chancen für Investoren in künstlicher Intelligenz",
        automateFinances: "Automatisieren Sie Ihre Finanzen: einrichten und vergessen für finanziellen Erfolg",
        beforeQuittingJob: "Bevor Sie kündigen: Finanzielle Überlegungen für Karrierewechsel",
        couplesFinance: "Finanzen als Paar verwalten: Kommunikation ist der Schlüssel",
        cryptoTaxGuide: "Kryptowährungssteuern: Verstehen Sie Ihre Pflichten",
        digitalNomadTax: "Remote von überall arbeiten: Steuern als digitaler Nomade navigieren",
        digitalScams: "Schützen Sie sich: Lernen Sie, digitale Betrügereien zu erkennen und zu vermeiden",
        esgGreenwashing: "ESG-Investitionen: Lernen Sie, echte nachhaltige Investitionen zu erkennen",
        fearOfInvesting: "Die Angst vor dem Investieren überwinden: Wissen ist Macht",
        financialPlanningChildren: "Elternschaft planen: Finanzielle Vorbereitung macht den Unterschied",
        howMuchToRetire: "Wie viel brauchen Sie für einen komfortablen Ruhestand?",
        inflationSavings: "Schützen Sie Ihre Ersparnisse vor Inflation mit klugen Strategien",
        investingMistakes: "Aus häufigen Investitionsfehlern lernen kann Ihnen Tausende sparen",
        investingWith100: "Klein anfangen: 100€ können der Beginn Ihrer Investitionsreise sein",
        irpfGuide: "Einkommensteuer verstehen: Ein umfassender Leitfaden",
        lowSalarySaving: "Jeder Euro zählt: Kluge Strategien zum Sparen bei niedrigem Gehalt",
        onePercentRule: "Die 1%-Regel: Kleine konsequente Verbesserungen führen zu großen Ergebnissen",
        preparingParenthood: "Finanzielle Vorbereitung ist entscheidend bevor Sie ein neues Familienmitglied willkommen heißen",
        rentingVsBuying: "Mieten vs Kaufen: Eine der größten finanziellen Entscheidungen, die Sie treffen werden",
        salaryNegotiation: "Meistern Sie die Kunst der Gehaltsverhandlung, um Ihr Einkommenspotenzial zu maximieren",
        selfEmployedFinances: "Selbstständigkeit: Freiheit erfordert finanzielle Disziplin",
        utilityBills: "Reduzieren Sie Ihre Nebenkosten mit klugen Strategien",
        whyTradersLose: "Warum verlieren die meisten Trader Geld? Psychologie und Statistiken verstehen",
      },
    },
  },
  fr: {
    images: {
      captions: {
        aiFinance: "L'Intelligence Artificielle transforme la gestion des finances personnelles",
        aiInvestment: "Révolution de l'IA: opportunités pour les investisseurs en intelligence artificielle",
        automateFinances: "Automatisez vos finances: configurez et oubliez pour le succès financier",
        beforeQuittingJob: "Avant de démissionner: considérations financières pour les transitions de carrière",
        couplesFinance: "Gérer les finances en couple: la communication est la clé",
        cryptoTaxGuide: "Impôts sur les cryptomonnaies: comprendre vos obligations",
        digitalNomadTax: "Travailler à distance de n'importe où: naviguer les impôts en tant que nomade digital",
        digitalScams: "Protégez-vous: apprenez à identifier et éviter les arnaques numériques",
        esgGreenwashing: "Investissement ESG: apprenez à identifier les investissements durables authentiques",
        fearOfInvesting: "Surmonter la peur d'investir: le savoir c'est le pouvoir",
        financialPlanningChildren: "Planifier la parentalité: la préparation financière fait toute la différence",
        howMuchToRetire: "Combien avez-vous besoin pour une retraite confortable?",
        inflationSavings: "Protégez votre épargne de l'inflation avec des stratégies intelligentes",
        investingMistakes: "Apprendre des erreurs d'investissement courantes peut vous faire économiser des milliers",
        investingWith100: "Commencer petit: 100€ peuvent être le début de votre parcours d'investisseur",
        irpfGuide: "Comprendre l'impôt sur le revenu: un guide complet",
        lowSalarySaving: "Chaque euro compte: stratégies intelligentes pour épargner avec un petit salaire",
        onePercentRule: "La règle du 1%: de petites améliorations constantes mènent à de grands résultats",
        preparingParenthood: "La préparation financière est essentielle avant d'accueillir un nouveau membre de la famille",
        rentingVsBuying: "Louer vs acheter: l'une des plus grandes décisions financières que vous prendrez",
        salaryNegotiation: "Maîtrisez l'art de la négociation salariale pour maximiser votre potentiel de revenus",
        selfEmployedFinances: "Travailleur indépendant: la liberté nécessite une discipline financière",
        utilityBills: "Réduisez vos factures de services avec des stratégies intelligentes",
        whyTradersLose: "Pourquoi la plupart des traders perdent de l'argent? Comprendre la psychologie et les statistiques",
      },
    },
  },
  hi: {
    images: {
      captions: {
        aiFinance: "कृत्रिम बुद्धिमत्ता व्यक्तिगत वित्त प्रबंधन को बदल रही है",
        aiInvestment: "AI क्रांति: कृत्रिम बुद्धिमत्ता में निवेशकों के लिए अवसर",
        automateFinances: "अपने वित्त को स्वचालित करें: वित्तीय सफलता के लिए सेट करें और भूल जाएं",
        beforeQuittingJob: "नौकरी छोड़ने से पहले: करियर परिवर्तन के लिए वित्तीय विचार",
        couplesFinance: "जोड़े के रूप में वित्त प्रबंधन: संचार महत्वपूर्ण है",
        cryptoTaxGuide: "क्रिप्टोकरेंसी कर: अपने दायित्वों को समझें",
        digitalNomadTax: "कहीं से भी दूर से काम करना: डिजिटल नोमैड के रूप में करों को नेविगेट करना",
        digitalScams: "खुद को सुरक्षित रखें: डिजिटल धोखाधड़ी को पहचानना और बचना सीखें",
        esgGreenwashing: "ESG निवेश: वास्तविक टिकाऊ निवेश की पहचान करना सीखें",
        fearOfInvesting: "निवेश के डर को दूर करना: ज्ञान ही शक्ति है",
        financialPlanningChildren: "पितृत्व की योजना: वित्तीय तैयारी सारा फर्क डालती है",
        howMuchToRetire: "आरामदायक सेवानिवृत्ति के लिए आपको कितना चाहिए?",
        inflationSavings: "स्मार्ट रणनीतियों से अपनी बचत को मुद्रास्फीति से बचाएं",
        investingMistakes: "सामान्य निवेश गलतियों से सीखना आपको हजारों बचा सकता है",
        investingWith100: "छोटी शुरुआत: ₹8,000 आपकी निवेश यात्रा की शुरुआत हो सकते हैं",
        irpfGuide: "आयकर को समझना: एक व्यापक मार्गदर्शिका",
        lowSalarySaving: "हर रुपया मायने रखता है: कम वेतन पर बचत के लिए स्मार्ट रणनीतियाँ",
        onePercentRule: "1% का नियम: छोटे लगातार सुधार बड़े परिणाम देते हैं",
        preparingParenthood: "नए परिवार के सदस्य का स्वागत करने से पहले वित्तीय तैयारी महत्वपूर्ण है",
        rentingVsBuying: "किराये पर लेना vs खरीदना: सबसे बड़े वित्तीय निर्णयों में से एक",
        salaryNegotiation: "अपनी कमाई की क्षमता को अधिकतम करने के लिए वेतन वार्ता की कला में महारत हासिल करें",
        selfEmployedFinances: "स्व-रोजगार: स्वतंत्रता के लिए वित्तीय अनुशासन आवश्यक है",
        utilityBills: "स्मार्ट रणनीतियों से अपने उपयोगिता बिलों को कम करें",
        whyTradersLose: "ज्यादातर ट्रेडर पैसे क्यों खोते हैं? मनोविज्ञान और आंकड़ों को समझना",
      },
    },
  },
};
